import { render, staticRenderFns } from "./orderfenxi.vue?vue&type=template&id=274e281c&scoped=true&"
import script from "./orderfenxi.vue?vue&type=script&lang=js&"
export * from "./orderfenxi.vue?vue&type=script&lang=js&"
import style0 from "./orderfenxi.vue?vue&type=style&index=0&id=274e281c&lang=scss&scoped=true&"
import style1 from "./orderfenxi.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e281c",
  null
  
)

export default component.exports